import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import {
  Card,
  Row,
  Col,
  Button,
  Spinner,
  Form,
  Table,
  Modal,
  Badge,
  InputGroup,
} from "react-bootstrap";
import "./EmployeeAttendance.css";
import moment from "moment";
import { useAuth } from "../../context/authContext";
import { toast, ToastContainer } from "react-toastify";
import { FaCheck, FaDotCircle } from "react-icons/fa";
import WFHApprovalModal from "./WFHApprovalModal";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function EmployeeAttendance() {
  const [viewMode, setViewMode] = useState("monthly");
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState([])
  const [currentMonthNumber, setCurrentMonthNumber] = useState(
    new Date().getMonth() + 1
  );

  const { isAdmin } = useAuth();
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const empName = storedUser.name || "";
  const empId = storedUser.employeeId || "";
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [escalatedEmployees, setEscalatedEmployees] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState(empId);
  const [leaveRecords, setLeaveRecords] = useState([]);
  const [satOffDates, setSatOffDates] = useState(new Set());
  const [satCompOffModal, setSatCompOffModal] = useState({ show: false, workedDate: '' });
  const [satCompOffForm, setSatCompOffForm] = useState({ compOffDate: '', duration: 'Full Day', toEmail: '' });
  const [satCompOffSending, setSatCompOffSending] = useState(false);
  const [multipleRecords, setMultipleRecords] = useState(false)
  const [newCc, setNewCc] = useState("");
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const today1 = new Date().toISOString().split("T")[0];
  const [isSending, setIsSending] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState([])
  const [showWfhModal, setShowWfhModal] = useState(false);
  const [SelectedWfhRecord, setSelectedWfhRecord] = useState([])

  const [leaveForm, setLeaveForm] = useState({
    leaveType: "Half/Full Day Request",
    leaveDate: [today1],
    to: "",
    ccList: ["tushar.mahadik@protovec.com", "kalpesh.urunkar@protovec.com"],
    subject: "Half/Full Day Request",
    body: "Dear Sir/Maam,\nPlease mark my attendance as Full Day for [insert date]. I was present, but due to [brief reason],\nThanks for your support.\nBest,",
    date: ''
  });

  const handleRemoveCc = (email) => {
    setLeaveForm((p) => ({
      ...p,
      ccList: p.ccList.filter((c) => c !== email),
    }));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setLeaveForm((prev) => {
      const updated = { ...prev };
      if (name === "body") {
        const count = value.trim().split(/\s+/).length;
        if (count > 500) return prev;
        updated.body = value;
      } else {
        updated[name] = value;
        if (name === "subject" && value !== "__custom") {
          updated.customSubject = "";
        }
      }
      return updated;
    });
  };

  const handleAddCc = (e) => {
    e.preventDefault();
    const email = newCc.trim();
    if (
      email &&
      !leaveForm.ccList.includes(email) &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ) {
      setLeaveForm((p) => ({ ...p, ccList: [...p.ccList, email] }));
    }
    setNewCc("");
  };

  const daysInMonth = useMemo(
    () => new Date(year, month + 1, 0).getDate(),
    [year, month]
  );
  const firstDayOfMonth = useMemo(
    () => new Date(year, month, 1).getDay(),
    [year, month]
  );

  const recordMap = useMemo(() => {
    const m = {};
    attendanceData.forEach((r) => {
      if (!m[r.date]) {
        m[r.date] = [];
      }
      m[r.date].push(r);
    });
    return m;
  }, [attendanceData]);

  const PresentCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode === 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.status !== "Present") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.status === "Present").length;
    }
  }, [attendanceData, month, year, viewMode]);

  const AbsentCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode === 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.status !== "Absent") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.status === "Absent").length;
    }
  }, [attendanceData, month, year, viewMode]);

  const LeaveCount = useMemo(() => {
    if (!leaveRecords || leaveRecords.length === 0) return 0;

    if (viewMode === 'monthly') {
      return leaveRecords.filter((leave) => {
        if (!leave.leave_date) return false;

        const [dd, mm, yyyy] = leave.leave_date.split("-");
        const leaveMonth = parseInt(mm) - 1; // Convert to 0-indexed month
        const leaveYear = parseInt(yyyy);

        return leaveMonth === month && leaveYear === year;
      }).length;
    } else {
      return leaveRecords.filter((leave) => {
        if (!leave.leave_date) return false;
        const [dd, mm, yyyy] = leave.leave_date.split("-");
        return parseInt(yyyy) === year;
      }).length;
    }
  }, [leaveRecords, month, year, viewMode]);

  const HolidayCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    const uniqueHolidays = new Set();

    attendanceData.forEach((record) => {
      if (!record.date || !record.holiday_name) return;

      if (viewMode === 'monthly') {
        const recordDate = new Date(record.date);
        if (recordDate.getMonth() === month && recordDate.getFullYear() === year) {
          uniqueHolidays.add(record.date);
        }
      } else {
        const recordDate = new Date(record.date);
        if (recordDate.getFullYear() === year) {
          uniqueHolidays.add(record.date);
        }
      }
    });

    return uniqueHolidays.size;
  }, [attendanceData, month, year, viewMode]);

  const HalfDayCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode === 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.status !== "Half_day") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.status === "Half_day").length;
    }
  }, [attendanceData, month, year, viewMode]);

  const CompensatoryLeaveCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode === 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || !record.isCompensatoryLeave) return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.isCompensatoryLeave).length;
    }
  }, [attendanceData, month, year, viewMode]);

  const PendingApprovalCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode === 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.status !== "Pending approval") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.status === "Pending approval").length;
    }
  }, [attendanceData, month, year, viewMode]);

  const WFHCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode == 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.location !== "WFH") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.location === "WFH").length;
    }

  }, [attendanceData, month, year, viewMode]);

  const SiteVisitCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    if (viewMode == 'monthly') {
      return attendanceData.filter((record) => {
        if (!record.date || record.status !== "Site_visit_present") return false;

        const recordDate = new Date(record.date);
        return (
          recordDate.getMonth() === month &&
          recordDate.getFullYear() === year
        );
      }).length;
    } else {
      return attendanceData.filter((r) => r.status === "Site_visit_present").length;
    }

  }, [attendanceData, month, year, viewMode]);

  const LateMarkCount = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) return 0;

    const lateDates = new Set();

    attendanceData.forEach((record) => {
      const isWfhHalfDay = record.location === "WFH" && parseFloat(record.work_hour || 0) < parseFloat(record.duration || 9);
      if (
        record.isHoliday ||
        record.isCompensatoryLeave ||
        !record.first_CI_time ||
        !record.ci_time ||
        !record.date ||
        record.status === "Half_day" ||
        record.status === "Half Day" ||
        record.status === "Incomplete Attendance" ||
        isWfhHalfDay ||
        record.status === "Site_visit_present" ||
        record.status === "Site_visit_incomplete"
      ) {
        return;
      }

      if (viewMode === "monthly") {
        const recordDate = new Date(record.date);
        if (
          recordDate.getMonth() !== month ||
          recordDate.getFullYear() !== year
        ) {
          return;
        }
      }

      const isLate = moment(record.first_CI_time, "YYYY-MM-DD h:mmA")
        .isAfter(
          moment(`${record.date} ${record.ci_time}`, "YYYY-MM-DD hh:mm A")
        );

      if (isLate) {
        lateDates.add(record.date);
      }
    });

    return lateDates.size;
  }, [attendanceData, month, year, viewMode]);

  const leaveMap = useMemo(() => {
    const m = {};
    leaveRecords.forEach((l) => {
      if (l.leave_date) {
        const [dd, mm, yyyy] = l.leave_date.split("-");
        const dateObj = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        const dateKey = `${yyyy}-${mm}-${dd}`;
        m[dateKey] = { l, ...dateObj };
      }
    });
    return m;
  }, [leaveRecords]);

  const handleRequestHalfFullDay = (rec) => {
    const isHoliday = rec?.isHoliday || holidays.includes(rec?.date);

    if (!isHoliday && rec.status === 'Incomplete Attendance') {
      setShowModal(true)
    }
  }

  useEffect(() => {
    if (!empId) return;
    axios
      .get(`${API_URL}/api/reports-by-id`, { params: { empId } })
      .then((res) => {
        setEscalatedEmployees(res.data || []);
      })
      .catch((err) => {
        console.error("Error loading dropdown:", err);
        setEscalatedEmployees([]);
      });
  }, [empId, showWfhModal]);

  useEffect(() => {
    if (!empName || !selectedEmpId) return;
    setLoading(true);

    const selectedEmpName =
      escalatedEmployees.find((e) => e.id === selectedEmpId)?.name || empName;
    setSelectedEmployee(escalatedEmployees.find((e) => e.id === selectedEmpId))
    const holReq = axios
      .get(`${API_URL}/api/holidays/holidays`, { params: { year } })
      .then((r) => r.data.map((h) => h.holiday_date))
      .then(setHolidays)
      .catch(() => setHolidays([]));

    const attReq = axios
      .get(`${API_URL}/api/attendance/calendar`, {
        params: { year, empName: selectedEmpName, empId: empId },
      })
      .then((r) => setAttendanceData(r.data))
      .catch(() => setAttendanceData([]));

    const empLeave = fetch(
      `${API_URL}/api/employeeleavesdate?employeeId=${selectedEmpId}`
    )
      .then((r) => r.json())
      .then((d) => setLeaveRecords(Array.isArray(d) ? d : []))
      .catch((err) => {
        console.error("Error fetching leave records:", err);
        setLeaveRecords([]);
      });

    Promise.all([holReq, attReq, empLeave]).finally(() => setLoading(false));
  }, [year, selectedEmpId, escalatedEmployees, empName]);

  // Fetch saturday off dates for current employee and month
  useEffect(() => {
    if (!selectedEmpId) return;
    const m = month + 1;
    axios
      .get(`${API_URL}/api/saturday-roster/assignments`, {
        params: { year, month: m }
      })
      .then((res) => {
        const data = res.data || [];
        const entry = data.find(d => String(d.employeeId) === String(selectedEmpId));
        setSatOffDates(new Set(entry?.offDates || []));
      })
      .catch(() => setSatOffDates(new Set()));
  }, [year, month, selectedEmpId]);

  const openSatCompOffModal = (dateKey) => {
    setSatCompOffForm({ compOffDate: '', duration: 'Full Day', toEmail: escalatedEmployees[0]?.email || '' });
    setSatCompOffModal({ show: true, workedDate: dateKey });
  };

  const submitSatCompOff = async () => {
    const { workedDate } = satCompOffModal;
    const { compOffDate, duration, toEmail } = satCompOffForm;
    if (!compOffDate || !toEmail) {
      toast.error("Please fill comp off date and select a manager.");
      return;
    }
    if (compOffDate <= workedDate) {
      toast.error("Comp off date must be after the worked date.");
      return;
    }
    setSatCompOffSending(true);
    try {
      const payload = {
        employee_id: selectedEmpId,
        from_email: storedUser.email,
        from_name: escalatedEmployees.find(e => e.id === selectedEmpId)?.name || empName,
        leave_type: "Compensatory Off (Leave)",
        to_email: toEmail,
        cc_email: "tushar.mahadik@protovec.com,kalpesh.urunkar@protovec.com",
        subject: `Compensatory Off (Leave) Request - Worked on Saturday Off (${workedDate})`,
        body: `Dear Sir/Ma'am,\n\nI worked on my assigned Saturday Off on ${workedDate}. I would like to request a Compensatory Off (Leave) on ${compOffDate}.\n\nThanks,\n${escalatedEmployees.find(e => e.id === selectedEmpId)?.name || empName}`,
        comp_off_records: [{ workedDate, duration, compOffDate }]
      };
      const res = await axios.post(`${API_URL}/api/send-leave-email`, payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("Comp Off request submitted successfully!");
        setSatCompOffModal({ show: false, workedDate: '' });
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to submit Comp Off request.");
    } finally {
      setSatCompOffSending(false);
    }
  };

  const handlePrevMonth = () =>
    setCurrentDate((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1));
  const handleNextMonth = () =>
    setCurrentDate((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1));
  const handlePrevYear = () =>
    setCurrentDate((d) => new Date(d.getFullYear() - 1, d.getMonth(), 1));
  const handleNextYear = () =>
    setCurrentDate((d) => new Date(d.getFullYear() + 1, d.getMonth(), 1));
  const handleToday = () => setCurrentDate(new Date());
  const handleYearChange = (e) => {
    const y = parseInt(e.target.value, 10) || year;
    setCurrentDate((d) => new Date(y, d.getMonth(), 1));
  };

  const today = new Date();
  const todayKey = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  const isLateCI = (rec) => {
    if (rec?.isHoliday || rec?.isCompensatoryLeave) return false;
    if (rec?.status === "Incomplete Attendance") return false;

    // Check if WFH Half Day (work_hour < duration)
    const isWfhHalfDay = rec?.location === "WFH" && parseFloat(rec?.work_hour || 0) < parseFloat(rec?.duration || 9);
    if (isWfhHalfDay) return false;

    if (!rec?.first_CI_time || !rec?.ci_time || !rec?.date) return false;

    return moment(rec.first_CI_time, "YYYY-MM-DD h:mmA").isAfter(
      moment(`${rec.date} ${rec.ci_time}`, "YYYY-MM-DD hh:mm A")
    );
  };

  const handleWfhClick = useCallback((record) => {
    setMultipleRecords(false);
    setShowWfhModal(true);
    setSelectedWfhRecord(record);
  }, []);

  const handleCloseWfhModal = useCallback(() => {
    setShowWfhModal(false);
    setMultipleRecords(false);
  }, []);

  const formatDateTime = (datetimeString) => {
    if (!datetimeString) return '—';
    try {
      const date = new Date(datetimeString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch {
      return datetimeString;
    }
  };
  const buildCalendar = () => {
    const cells = [];

    const total = firstDayOfMonth + daysInMonth;

    for (let i = 0; i < total; i++) {
      if (i < firstDayOfMonth) {
        cells.push(<td key={`empty-${i}`} className="empty-cell" />);
      } else {
        const day = i - firstDayOfMonth + 1;
        const mm = String(month + 1).padStart(2, "0");
        const dd = String(day).padStart(2, "0");
        const key = `${year}-${mm}-${dd}`;
        const recList = recordMap[key] || [];
        const rec = recList[0];
        const leaveRec = leaveMap[key];
        const isHoliday = rec?.isHoliday || holidays.includes(key);
        const isPureHoliday = !rec && holidays.includes(key);
        const isToday = key === todayKey;

        // Check if it's Sunday
        const dateObj = new Date(year, month, day);
        const isSunday = dateObj.getDay() === 0;
        const isSatOff = dateObj.getDay() === 6 && satOffDates.has(key);

        // Check if any record has CI or CO entry
        const hasCIorCO = recList.some(
          (record) => record.in_time || record.out_time
        );

        // Check if it's a travel day
        const isTravelDay = rec?.isTravelDay;

        // Build tooltip content
        const getTooltipContent = () => {
          let tooltip = ``;

          if (isTravelDay && rec?.travel_info && rec.travel_info.length > 0) {
            tooltip += `\n🚗 Travel: ${rec.travel_info[0]?.location?.replace('🚗 ', '') || 'Site Visit'}`;
            rec.travel_info.forEach((travel, index) => {
              tooltip += `\n  Trip ${index + 1}: ${formatDateTime(travel.from_datetime)} - ${formatDateTime(travel.to_datetime)}`;
              if (travel.location) {
                tooltip += ` (${travel.location})`;
              }
            });
            if (rec.in_time) {
              tooltip += `\nCI: ${rec.first_CI_time?.split(' ')[1] || rec.in_time.split(' ')[1]}`;
            }
            if (rec.out_time) {
              tooltip += `\nCO: ${rec.last_CO_time?.split(' ')[1] || rec.out_time.split(' ')[1]}`;
            }
            if (rec.work_hour) {
              tooltip += `\nWork Hours: ${rec.work_hour}h`;
            }
          } else if (rec) {
            if (rec.in_time) {
              tooltip += `\nCI: ${rec.first_CI_time?.split(' ')[1] || rec.in_time.split(' ')[1]}`;
            }
            if (rec.out_time) {
              tooltip += `\nCO: ${rec.last_CO_time?.split(' ')[1] || rec.out_time.split(' ')[1]}`;
            }
            if (rec.work_hour) {
              tooltip += `\nWork Hours: ${rec.work_hour}h`;
            }
            if (rec.status) {
              tooltip += `\nStatus: ${rec.status.replaceAll('_', ' ')}`;
            }
            if (rec.location && rec.location !== 'WFH') {
              tooltip += `\nLocation: ${rec.location}`;
            }
          } else if (leaveRec) {
            tooltip += `\n${leaveRec.l.leave_type}: ${leaveRec.l.leave_day} Day`;
          } else if (isHoliday) {
            tooltip += `\n${rec?.holiday_name || 'Holiday'}`;
          } else if (isSunday) {
            tooltip += '\nSunday';
          }

          return tooltip;
        };

        cells.push(
          <td
            key={key}
            className="calendar-day-cell"
            title={getTooltipContent()}
            onClick={() => {
              if (recList.length > 0 && hasCIorCO) {
                setMultipleRecords(true);
                setSelectedData(recList);
              }
            }}
          >
            {/* Day number */}
            <div
              className="day-number fw-semibold"
              style={
                isToday
                  ? {
                    backgroundColor: "#0d6efd",
                    color: "#fff",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    lineHeight: "28px",
                    textAlign: "center",
                    display: "inline-block",
                  }
                  : {}
              }
            >
              {day}
            </div>

            {/* Show holiday label for Sunday or holiday WITH attendance records */}
            {(isSunday || isHoliday) && (
              <div
                className="event holiday fw-bold"
                style={{
                  backgroundColor: isSunday ? "#ff9900" : "#ff0000",
                  color: "#fff",
                  marginBottom: rec ? "2px" : "0",
                  fontSize: rec ? "0.8em" : "1em"
                }}
              >
                {isSunday ? "Sunday" : (rec?.holiday_name || "Holiday")}
              </div>
            )}

            {/* Leave overlay */}
            {leaveRec && (
              <div
                className="event leave fw-bold"
                style={{
                  backgroundColor: "#ff0000",
                  color: "#fff",
                  marginTop: rec?.isHoliday || isPureHoliday ? "4px" : "0"
                }}
              >
                {leaveRec.l.leave_type === "Late Mark"
                  ? `Late Mark (${leaveRec.l.leave_day})`
                  : `On Leave (${leaveRec.l.leave_day} Day)`}
              </div>
            )}

            {/* Saturday Off tag */}
            {isSatOff && (
              <div
                className="event fw-bold"
                style={{
                  backgroundColor: "#f97316",
                  color: "#fff",
                  marginTop: "2px",
                  fontSize: "0.78em"
                }}
              >
                Sat Off
              </div>
            )}

            {/* COMP-OFF TAG (Purple) - Separate from work entry */}
            {rec && rec.hasCompOff && (
              <div
                className="event fw-bold"
                style={{
                  backgroundColor: rec.compOffColor || "#9370DB",
                  color: "#fff",
                  marginTop: (isSunday || isHoliday) ? "2px" : "0"
                }}
              >
                {rec.compOffStatus || "Compensatory Leave"}
              </div>
            )}

            {/* WORK ENTRY TAG (Separate from comp-off) */}
            {rec && rec.hasWork && (
              <div
                className="event"
                style={{
                  backgroundColor: rec.workColor || "#90EE90",
                  color: "#000",
                  marginTop: rec.hasCompOff ? "2px" : ((isSunday || isHoliday) ? "2px" : "0"),
                  border: "1px solid #ccc"
                }}
              >
                <div className="flex space-between items-center fw-bold">
                  {rec.workLocation === 'WFH' && (rec.wfh_approved === 1 ? (
                    <FaCheck color="green" className="me-1" onClick={() => handleWfhClick(rec)} />
                  ) : (
                    <FaDotCircle color="red" className="me-1" onClick={() => handleWfhClick(rec)} />
                  ))}
                  {rec.workStatus === "Site_visit_present" || rec.workStatus === "Site_visit_incomplete" ? (
                    rec.workStatus === "Site_visit_incomplete" ? (
                      <span>{`SV(${rec.workLocation})`} <span style={{ color: "#cc0000" }}>- Incomplete</span></span>
                    ) : (
                      `SV(${rec.workLocation})`
                    )
                  ) : (
                    rec.workStatus?.replaceAll("_", " ") || "Present"
                  )}
                </div>
                {rec.in_time && (
                  <div style={{ fontSize: "0.9em", fontWeight: "normal" }}>
                    CI {rec?.first_CI_time?.split(" ")[1]}
                  </div>
                )}
                {rec.out_time && (
                  <div style={{ fontSize: "0.9em", fontWeight: "normal" }}>
                    CO {rec?.last_CO_time?.split(" ")[1]}
                  </div>
                )}
              </div>
            )}

            {/* Travel block - Show when there's travel info and no comp-off */}
            {isTravelDay && !rec?.hasCompOff && (
              <div
                className="event"
                style={{
                  backgroundColor: "#87CEEB",
                  color: "#000",
                  marginTop: (isSunday || isHoliday) ? "2px" : "0",
                  border: "1px solid #5F9EA0"
                }}
              >
                <div className="flex space-between items-center fw-bold">
                  <span>🚗 {rec?.travel_info?.[0]?.location?.replace('🚗 ', '') || 'Travel'}</span>
                </div>
                {/* {rec?.travel_info && rec.travel_info.length > 0 && (
                <div style={{ fontSize: "0.8em", fontWeight: "normal" }}>
                  {new Date(rec.travel_info[0].from_datetime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} - {new Date(rec.travel_info[0].to_datetime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                </div>
              )} */}
              </div>
            )}

            {/* Regular CICO block (non-comp-off, non-work days) */}
            {rec && !rec.hasCompOff && !rec.hasWork && rec.status && rec.status !== "Holiday" && rec.status !== "Sunday" && !rec.isTravelDay && (
              <div
                className="event"
                style={{
                  backgroundColor: rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete"
                    ? "#FFFF00"
                    : rec.location === "WFH"
                      ? "rgb(244 211 188)"
                      : rec.color,
                  color: rec.location === "WFH"
                    ? "#000"
                    : (rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete")
                      ? "#000"
                      : rec.color === "#ff0000" || rec.color === "#ff9900"
                        ? "#fff"
                        : "#000",
                  marginTop: isTravelDay ? "2px" : (isSunday || isHoliday) ? "2px" : "0",
                  border: rec.location === "WFH"
                    ? "1px solid rgb(244 211 188)"
                    : (rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete")
                      ? "1px solid #d4d400"
                      : "none"
                }}
              >
                <div className="flex space-between items-center fw-bold">
                  {rec.location === 'WFH' && (rec.wfh_approved === 1 ? (
                    <FaCheck color="green" className="me-1" onClick={() => handleWfhClick(rec)} />
                  ) : (
                    <FaDotCircle color="red" className="me-1" onClick={() => handleWfhClick(rec)} />
                  ))}
                  {rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete" ? (
                    rec.status === "Site_visit_incomplete" ? (
                      <span>{`SV(${rec.location})`} <span style={{ color: "#cc0000" }}>- Incomplete Attendance</span></span>
                    ) : (
                      `SV(${rec.location})`
                    )
                  ) : (isLateCI(rec) && rec.status !== "Half_day" && !rec.isHoliday) ? (
                    <span>
                      <u style={{ textDecoration: "underline", textDecorationThickness: "1.5px", textDecorationColor: "red" }}>
                        {rec.status.replaceAll("_", " ")}
                      </u>
                    </span>
                  ) : (
                    rec.status.replaceAll("_", " ")
                  )}
                </div>
                {rec.in_time && (
                  <div style={{ fontSize: "0.9em", fontWeight: "normal" }}>
                    CI {rec?.first_CI_time?.split(" ")[1]}
                  </div>
                )}
                {rec.out_time && (
                  <div style={{ fontSize: "0.9em", fontWeight: "normal" }}>
                    CO {rec?.last_CO_time?.split(" ")[1]}
                  </div>
                )}
              </div>
            )}
          </td>
        );
      }
    }

    const rows = [];
    for (let r = 0; r < cells.length; r += 7) {
      rows.push(<tr key={r}>{cells.slice(r, r + 7)}</tr>);
    }
    return rows;
  };
  const buildYearlyView = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();

    const monthsToShow =
      year === currentYear ? monthNames.slice(0, currentMonth + 1) : monthNames;

    return (
      <div className="yearly-view m-4">
        <Row className="g-4">
          {monthsToShow.map((monthName, index) => {
            const monthKey = index + 1;
            const daysInMonth = new Date(year, monthKey, 0).getDate();
            const firstDay = new Date(year, index, 1).getDay();
            const totalDays = firstDay + daysInMonth;
            const weeksInMonth = Math.ceil(totalDays / 7);

            const isFutureMonth = year === currentYear && index > currentMonth;
            const isCurrentMonth = year === currentYear && index === currentMonth;

            return (
              <Col key={monthName} xs={12} sm={6} md={3}>
                <div className="mb-1">
                  <p className="text-center fw-semibold">{monthName}</p>

                  <Card.Body>
                    <Table size="sm" className="mb-3">
                      <thead>
                        <tr>
                          {daysOfWeek.map((d) => (
                            <th
                              key={d}
                              className="text-center"
                              style={{ fontSize: "10px" }}
                            >
                              {d[0]}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: weeksInMonth }).map((_, weekIndex) => (
                          <tr key={weekIndex}>
                            {Array.from({ length: 7 }).map((_, dayIndex) => {
                              const dayNumber = weekIndex * 7 + dayIndex - firstDay + 1;
                              if (dayNumber <= 0 || dayNumber > daysInMonth) {
                                return <td key={dayIndex} className="empty-cell"></td>;
                              }

                              const mm = String(monthKey).padStart(2, "0");
                              const dd = String(dayNumber).padStart(2, "0");
                              const key = `${year}-${mm}-${dd}`;
                              const recList = recordMap[key] || [];
                              const rec = recList[0];
                              const leaveRec = leaveMap[key];
                              const isHoliday = rec?.isHoliday || holidays.includes(key);
                              const isToday = key === todayKey;

                              const isFutureDate =
                                year === currentYear &&
                                (index > currentMonth ||
                                  (index === currentMonth && dayNumber > currentDay));

                              // Check if person worked
                              const hasWorked = rec?.in_time && rec?.out_time && parseFloat(rec?.work_hour) > 0;
                              const isWorkedOnHoliday = rec?.isWorkedOnHoliday;
                              const isCompensatoryLeave = rec?.isCompensatoryLeave && !hasWorked;
                              const isTravelDay = rec?.isTravelDay;

                              let backgroundColor = "";
                              let color = "#000";
                              let tooltip = `${dayNumber}`;

                              // Check if it's Sunday
                              const dateObj = new Date(year, index, dayNumber);
                              const isSunday = dateObj.getDay() === 0;

                              // TRAVEL DAY - Check this first as it's a special case
                              if (isTravelDay) {
                                backgroundColor = "#87CEEB"; // Sky blue for travel
                                color = "#000";
                                tooltip += ` - Travel: ${rec?.status?.replace('🚗 ', '') || 'Site Visit'}`;
                                if (rec?.travel_info && rec.travel_info.length > 0) {
                                  const times = rec.travel_info.map(t =>
                                    `${new Date(t.from_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}-${new Date(t.to_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
                                  ).join(', ');
                                  tooltip += ` (${times})`;
                                }
                              }
                              // Worked on holiday - FIXED: Check for site visit first
                              else if (isWorkedOnHoliday && hasWorked) {
                                if (rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete") {
                                  backgroundColor = "#FFFF00"; // YELLOW for site visit on holiday
                                  color = "#000";
                                  tooltip += " - Site Visit";
                                  if (rec?.holiday_name) {
                                    tooltip += ` (${rec.holiday_name})`;
                                  } else if (isSunday) {
                                    tooltip += " (Sunday)";
                                  }
                                } else if (rec.status === "WFH") {
                                  backgroundColor = "rgb(244 211 188)";
                                  tooltip += " - Work From Home";
                                  if (rec?.holiday_name) {
                                    tooltip += ` (${rec.holiday_name})`;
                                  } else if (isSunday) {
                                    tooltip += " (Sunday)";
                                  }
                                } else if (rec.status === "Pending approval") {
                                  backgroundColor = "#FFA500";
                                  tooltip += " - Pending approval";
                                  if (rec?.holiday_name) {
                                    tooltip += ` (${rec.holiday_name})`;
                                  } else if (isSunday) {
                                    tooltip += " (Sunday)";
                                  }
                                } else {
                                  backgroundColor = "#90EE90"; // Light green for regular work on holiday
                                  color = "#000";
                                  tooltip += " - Present";
                                  if (rec?.holiday_name) {
                                    tooltip += ` (${rec.holiday_name})`;
                                  } else if (isSunday) {
                                    tooltip += " (Sunday)";
                                  }
                                }
                              }
                              // Normal work day (not holiday)
                              else if (hasWorked && !isHoliday) {
                                if (rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete") {
                                  backgroundColor = "#FFFF00"; // Yellow for site visit
                                  color = "#000";
                                  tooltip += " - Site Visit";
                                } else if (rec.location === "WFH") {
                                  backgroundColor = "rgb(244 211 188)";
                                  tooltip += " - Work From Home";
                                } else if (rec.status === "Present") {
                                  backgroundColor = "#28a745"; // Dark green for normal present
                                  color = "#fff";
                                  tooltip += " - Present";
                                } else if (rec.status === "Absent") {
                                  backgroundColor = "#dc3545";
                                  color = "#fff";
                                  tooltip += " - Absent";
                                } else if (rec.status === "Half_day") {
                                  backgroundColor = "#B0E0E6";
                                  tooltip += " - Half Day";
                                } else if (rec.first_CI_time > rec.ci_time) {
                                  backgroundColor = "#90EE90"; // Light green for late mark
                                  tooltip += " - Late Mark";
                                } else if (rec.status === "Pending approval") {
                                  backgroundColor = "#FFA500";
                                  tooltip += " - Pending approval";
                                } else {
                                  backgroundColor = rec.color || "#6c757d";
                                  color = ["#ff0000", "#9370DB", "#dc3545", "#28a745", "#0d6efd"].includes(backgroundColor)
                                    ? "#fff"
                                    : "#000";
                                  tooltip += ` - ${rec.status?.replace("_", " ") || "No status"}`;
                                }
                              }
                              // Compensatory leave (only if didn't work)
                              else if (isCompensatoryLeave) {
                                backgroundColor = "#9370DB";
                                color = "#fff";
                                tooltip += " - Compensatory Leave";
                              }
                              // Future date
                              else if (isFutureDate) {
                                backgroundColor = "#f8f9fa";
                                tooltip += " - Future date";
                              }
                              // Holiday (no work)
                              else if (isHoliday) {
                                backgroundColor = isSunday ? "#ff9900" : "#ffc107"; // Orange for Sunday, yellow for other holidays
                                color = "#fff";
                                tooltip += ` - ${rec?.holiday_name || (isSunday ? "Sunday" : "Holiday")}`;
                              }
                              // Regular leave
                              else if (leaveRec) {
                                backgroundColor = "#dc3545";
                                color = "#fff";
                                tooltip += " - On Leave";
                              }
                              // No attendance record
                              else {
                                if (
                                  year < currentYear ||
                                  (year === currentYear &&
                                    (index < currentMonth ||
                                      (index === currentMonth && dayNumber < currentDay)))
                                ) {
                                  backgroundColor = "#dc3545";
                                  color = "#fff";
                                  tooltip += " - Absent (No record)";
                                } else {
                                  backgroundColor = "#f8f9fa";
                                  tooltip += " - No data";
                                }
                              }

                              // Today highlight
                              if (isToday) {
                                backgroundColor = "#0d6efd";
                                color = "#fff";
                                tooltip += " - Today";
                              }

                              return (
                                <td
                                  key={dayIndex}
                                  className="text-center"
                                  style={{
                                    padding: "5px",
                                    fontSize: "12px",
                                    backgroundColor,
                                    color,
                                    cursor: "pointer",
                                    fontWeight: "500",
                                  }}
                                  title={tooltip}
                                  onClick={() => {
                                    // Optional: Show travel details on click
                                    if (isTravelDay && rec?.travel_info) {
                                      // You can add a modal here to show travel details
                                      console.log('Travel details:', rec.travel_info);
                                    }
                                  }}
                                >
                                  {dayNumber}
                                  {isTravelDay && (
                                    <span style={{ marginLeft: '2px' }}>🚗</span>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" /> Loading…
      </div>
    );
  }

  const ColorLegend = () => (
    <div className="color-legend">
      <div className="d-flex flex-wrap gap-3">
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#28a745" }}
          ></div>
          <span>Present {PresentCount > 0 && `(${PresentCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#dc3545" }}
          ></div>
          <span>
            Absent {AbsentCount > 0 && `(${AbsentCount})`} /
            Leave {LeaveCount > 0 && `(${LeaveCount})`}
          </span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#ffc107" }}
          ></div>
          <span>Holiday {HolidayCount > 0 && `(${HolidayCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#0d6efd" }}
          ></div>
          <span>Today</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "yellow" }}
          ></div>
          <span>Site Visit {SiteVisitCount > 0 && `(${SiteVisitCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "rgb(176, 224, 230)" }}
          ></div>
          <span>Half Day {HalfDayCount > 0 && `(${HalfDayCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{
              backgroundColor: "rgb(144, 238, 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "20px",
              height: "20px",
              color: 'red',
            }}
          >
            _
          </div>
          <span>Late Mark {LateMarkCount > 0 && `(${LateMarkCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "rgb(244 211 188)" }}
          ></div>
          <span title="Work From Home">WFH {WFHCount > 0 && `(${WFHCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{
              backgroundColor: "#9370DB",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "500"
            }}
          >
          </div>
          <span title="Compensatory Leave">Compensatory Leave {CompensatoryLeaveCount > 0 && `(${CompensatoryLeaveCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{
              backgroundColor: "#FFA500",
              color: "#000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "500"
            }}
          >
          </div>
          <span title="Pending Approval">Pending Approval {PendingApprovalCount > 0 && `(${PendingApprovalCount})`}</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#87CEEB" }}
          ></div>
          <span title="Travel/Site Visit">Travel 🚗</span>
        </div>
        <div className="d-flex align-items-center">
          <div
            className="legend-color-box me-2"
            style={{ backgroundColor: "#f97316" }}
          ></div>
          <span title="Saturday Off">Sat Off</span>
        </div>
      </div>
    </div>
  );

  const handleSetMail = () => {
    setMultipleRecords(false)
    setShowModal(true)
    setLeaveForm(prev => ({
      ...prev,
      leaveDate: selectedData[0]?.date,
      date: selectedData[0]?.date
    }));
  }

  const handleFullDayMail = async () => {
    if (isSending) return;
    if (!leaveForm.to || !leaveForm.body.trim()) {
      toast.error("Please fill in To and Body fields before sending.");
      return;
    }
    setIsSending(true);

    const payload = {
      employee_id: selectedEmployee.id,
      from_email: selectedEmployee.email,
      from_name: selectedEmployee.name,
      leave_type: leaveForm.leaveType,
      leave_date: leaveForm.leaveDate || [],
      to_email: leaveForm.to,
      cc_email: leaveForm.ccList.join(","),
      subject: leaveForm.subject,
      body: leaveForm.body,
      date: selectedData[0]?.date
    };

    try {
      const res = await fetch(`${API_URL}/api/send-leave-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error();
      toast.success("Email sent successfully!");
      setLeaveForm({
        leaveType: "Half/Full Day Request",
        leaveDate: [today1],
        to: "",
        ccList: ["tushar.mahadik@protovec.com", "kalpesh.urunkar@protovec.com"],
        subject: "Half/Full Day Request",
        body: "Dear Sir/Maam,\nPlease mark my attendance as Full Day for [insert date]. I was present, but due to [brief reason],\nThanks for your support.\nBest,",
        date: ''
      });
    } catch {
      toast.error("Error sending email");
    } finally {
      setIsSending(false);
      setShowModal(false);
    }
  }

  return (
    <div className="m-1">
      <div className="ea-filter-bar">
        {/* Row 1: Year + View Mode + Nav (all inline on mobile) */}
        <div className="ea-filter-row1">
          <Form.Group className="ea-filter-item-year">
            <Form.Label className="ea-filter-label">Year</Form.Label>
            <Form.Control
              type="number"
              min="2000"
              max="2100"
              value={year}
              onChange={handleYearChange}
              size="sm"
              className="ea-year-input"
            />
          </Form.Group>
          <Form.Group className="ea-filter-item-emp">
            <Form.Label className="ea-filter-label">Employee</Form.Label>
            <Form.Select
              value={selectedEmpId || ""}
              onChange={(e) => setSelectedEmpId(Number(e.target.value))}
              size="sm"
            >
              <option value={empId}>{empName} (You)</option>
              {escalatedEmployees
                .filter((emp) => emp.id !== empId)
                .map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="ea-filter-item-view">
            <Form.Label className="ea-filter-label">View</Form.Label>
            <div style={{ display: "flex", border: "1px solid #0d6efd", borderRadius: "6px", overflow: "hidden" }}>
              <button
                onClick={() => setViewMode("monthly")}
                style={{
                  padding: "4px 10px",
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  border: "none",
                  background: viewMode === "monthly" ? "#0d6efd" : "#fff",
                  color: viewMode === "monthly" ? "#fff" : "#0d6efd",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Monthly
              </button>
              <button
                onClick={() => setViewMode("yearly")}
                style={{
                  padding: "4px 10px",
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  border: "none",
                  borderLeft: "1px solid #0d6efd",
                  background: viewMode === "yearly" ? "#0d6efd" : "#fff",
                  color: viewMode === "yearly" ? "#fff" : "#0d6efd",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Yearly
              </button>
            </div>
          </Form.Group>

          <div className="ea-filter-item-nav">
            <div className="ea-nav-group">
              <Button onClick={handleToday} size="sm" className="ea-today-btn">Today</Button>
              <div className="d-flex align-items-center">
                {viewMode === "monthly" ? (
                  <>
                    <Button onClick={handlePrevMonth} size="sm">&larr;</Button>
                    <span className="mx-2 fw-semibold ea-nav-label">{monthNames[month]} {year}</span>
                    <Button onClick={handleNextMonth} size="sm">&rarr;</Button>
                  </>
                ) : (
                  <>
                    <Button onClick={handlePrevYear} size="sm">&larr;</Button>
                    <span className="mx-2 fw-semibold ea-nav-label">{year}</span>
                    <Button onClick={handleNextYear} size="sm">&rarr;</Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>

      {<ColorLegend />}

      <div className="calendar-wrapper">
        <Col className="calendar-container">
          <Card.Body>
            {viewMode === "monthly" ? (
              <div className="calendar-container">
                <Table className="calendar-table" size="sm">
                  <thead>
                    <tr>
                      {daysOfWeek.map((d) => (
                        <th key={d} className="text-center">
                          {d}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>{buildCalendar()}</tbody>
                </Table>
              </div>
            ) : (
              buildYearlyView()
            )}
          </Card.Body>
        </Col>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header className="border-0 pb-0">
          <Modal.Title>Half/Full Day Request</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            padding: "1rem 1.5rem",
          }}
        >
          <div className="d-flex gap-3">
            <p className="mb-1"><b>Request Type :</b> {leaveForm.leaveType}</p>
            <p className="mb-1"><b>Date :</b> {selectedData[0]?.date}</p>
          </div>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1"><b>To</b></Form.Label>
            <Form.Control
              type="email"
              name="to"
              value={leaveForm.to}
              onChange={handleFormChange}
              required
            />
            <Form.Control.Feedback type="invalid">
              Please enter a valid email.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="mb-1"><b>CC</b></Form.Label>
            <div className="mb-2">
              {leaveForm.ccList.map((c) => (
                <Badge
                  key={c}
                  pill
                  bg="secondary"
                  className="me-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleRemoveCc(c)}
                >
                  {c} &times;
                </Badge>
              ))}
            </div>
            <InputGroup>
              <Form.Control
                type="email"
                placeholder="Add CC"
                value={newCc}
                onChange={(e) => setNewCc(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddCc(e)}
              />
              <Button onClick={handleAddCc}>Add</Button>
            </InputGroup>
          </Form.Group>

          <p className="mb-1"><b>Subject :</b> {leaveForm.subject}</p>

          <Form.Group className="">
            <Form.Label className="mb-1"><b>Body</b></Form.Label>

            <Form.Control
              as="textarea"
              name="body"
              rows={2}
              value={leaveForm.body}
              onChange={handleFormChange}
              required
            />
            <Form.Text className="text-muted">
              {leaveForm.body
                .trim()
                .split(/\s+/)
                .filter(Boolean).length}
              /500 words
            </Form.Text>

            <Form.Control.Feedback type="invalid">
              Please enter the email body.
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 mt-0 pt-0">
          <Button
            size="sm"
            variant="primary"
            onClick={handleFullDayMail}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={multipleRecords}
  onHide={() => {
    setMultipleRecords(false);
    setSelectedData([]);
  }}
  size="sm"
  centered
>
  <Modal.Header className="border-0 pb-0">
    <Modal.Title>{selectedData[0]?.date}</Modal.Title>
  </Modal.Header>

  <Modal.Body
    style={{
      maxHeight: "60vh",
      overflowY: "auto",
      padding: "1rem 1rem",
    }}
  >
    {selectedData?.length > 0 &&
      selectedData.map((rec, idx) => (
        <div key={idx} className="mb-2 pb-2">

          {/* STATUS */}
          <p className="mb-1">
            <b>Status:</b>{" "}
            {rec.status === "Site_visit_present" || rec.status === "Site_visit_incomplete"
              ? `SV (${rec.location})`
              : rec.status?.replace("_", " ") || "Unknown"}
          </p>

          {/* MULTIPLE ENTRIES */}
          {rec.all_entries && rec.all_entries.length > 0 ? (
            rec.all_entries.map((entry, i) => (
              <div key={i} className="ps-2 mb-2">

                <div className="d-flex gap-3">
                  {entry.in_time && (
                    <p className="mb-1">
                      <b>CI:</b> {entry.in_time.split(" ")[1]}
                    </p>
                  )}
                  {entry.out_time && (
                    <p className="mb-1">
                      <b>CO:</b> {entry.out_time.split(" ")[1]}
                    </p>
                  )}
                </div>

                {entry.work_hour && (
                  <p className="mb-1">
                    <b>Work Hour:</b> {entry.work_hour} <b>h</b>
                  </p>
                )}

                {/* LINE BETWEEN ENTRIES */}
                {i !== rec.all_entries.length - 1 && (
                  <hr className="my-1" />
                )}
              </div>
            ))
          ) : (
            <>
              <div className="d-flex gap-3">
                {rec.in_time && (
                  <p className="mb-1">
                    <b>CI:</b> {rec.in_time.split(" ")[1]}
                  </p>
                )}
                {rec.out_time && (
                  <p className="mb-1">
                    <b>CO:</b> {rec.out_time.split(" ")[1]}
                  </p>
                )}
              </div>

              {rec.work_hour && (
                <p className="mb-1">
                  <b>Work Hour:</b> {rec.work_hour} <b>h</b>
                </p>
              )}
            </>
          )}

          {/* ✅ LINE BEFORE TOTAL */}
          <hr className="my-2 opacity-50" />

    
 {selectedData?.length > 0 && (() => {
            const totalWorkHours = selectedData.reduce(
              (sum, rec) => sum + (parseFloat(rec.work_hour) || 0),
              0
            );

            return (
              <div className="mt-2 pt-2">
                <p className="mb-0">
                  <b>Total Work Hours:</b> {totalWorkHours.toFixed(2)} <b>h</b>
                </p>

                {Number(totalWorkHours) > 5 && Number(totalWorkHours) < 8.5 &&
                  selectedData[0]?.full_request !== 1 && (
                    <div className="mt-2">
                      <button className="btn btn-primary btn-sm" onClick={handleSetMail}>
                        Submit Adjustment Request
                      </button>
                    </div>
                  )}

              </div>
            );
          })()}

        </div>
      ))}
  </Modal.Body>
</Modal>

      <WFHApprovalModal
        show={showWfhModal}
        onHide={handleCloseWfhModal}
        employeeName={escalatedEmployees.find(emp => emp.id === selectedEmpId)?.name}
        requestDate={SelectedWfhRecord?.date || ""}
        oldComment={SelectedWfhRecord?.comment || ''}
        oldIsApproved={SelectedWfhRecord?.wfh_approved}
        storedUser={storedUser}
      />
      <ToastContainer />
    </div>
  );
}